import React, { type FunctionComponent } from 'react'
import { LogOutIcon, StoreIcon, TechnicalIcon } from '@instacart/ids-core'
import { useBooleanState } from '@retailer-platform/shared-components'
import { NavItem } from '../NavItem'
import { AdminControlModal } from '../../../admin-controls-modal/AdminControlsModal'

export const AdminNavFooterContent: FunctionComponent = () => {
  const [isAdminControlsOpen, openAdminControls, closeAdminControls] = useBooleanState(false)

  return (
    <React.Fragment>
      <>
        <NavItem
          isMainItem
          Icon={TechnicalIcon}
          title="app.admin.nav.links.adminControls"
          onClick={openAdminControls}
        />
        <AdminControlModal isOpen={isAdminControlsOpen} onClose={closeAdminControls} />
      </>
      <NavItem title="app.admin.nav.links.retailerDashboard" route="scope" Icon={StoreIcon} />
      <NavItem title="app.admin.nav.links.logOut" route="log-out" Icon={LogOutIcon} />
    </React.Fragment>
  )
}
